import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	spotlightTitle: {
		defaultMessage: 'AI drafts to save time',
		description: 'Ai generated drafts onboarding Title',
		id: 'servicedesk-knowledge-performance.suggested-topics-table.create-article.create-article.ai-draft-gen-change-boarding.spotlight-title',
	},
	spotlightDescription: {
		defaultMessage:
			"We've made it easier to write knowledge article with pre-generated drafts for the most common requests in your project.",
		description: 'Ai generated drafts onboarding description',
		id: 'servicedesk-knowledge-performance.suggested-topics-table.create-article.create-article.ai-draft-gen-change-boarding.spotlight-description',
	},
	spotlightCta: {
		defaultMessage: 'OK',
		description: 'CTA text for Ai generated drafts onboarding description',
		id: 'servicedesk-knowledge-performance.suggested-topics-table.create-article.create-article.ai-draft-gen-change-boarding.spotlight-cta',
	},
});
